const delegationActionTypes = {
  GET_ASSISTANTS: "GET_ASSISTANTS",
  SET_ASSISTANTS_LOADING: "SET_ASSISTANTS_LOADING",
  GET_ASSISTANTS_FOR: "GET_ASSISTANTS_FOR",
  SET_ASSISTANTS_FOR_LOADING: "SET_ASSISTANTS_FOR_LOADING",
  SET_EMPTY_ASSISTANTS: "SET_EMPTY_ASSISTANTS",
};

export default delegationActionTypes;
